'use strict';

/** @type {import('./eval')} */
module.exports = EvalError;



//////////////////
// WEBPACK FOOTER
// ./~/_es-errors@1.3.0@es-errors/eval.js
// module id = 1368
// module chunks = 0